import { prefixerI } from '.'

export const ROUTE_ANEXOS = prefixerI('anexos')
export const ROUTE_ANEXOS_ACTIVOS_FIJOS = prefixerI('anexos-activos-fijos')
export const ROUTE_BALANCE_COMPROBACION = prefixerI('balance-comprobacion')
export const ROUTE_BALANCE_COMPROBACION_SEGMENTADO = prefixerI('balance-comprobacion-segmentado')
export const ROUTE_BALANCE_GENERAL = prefixerI('balance-general')
export const ROUTE_BALANCE_DINAMICO = prefixerI('balance-dinamico')
export const ROUTE_CONCILIACION_CUENTAS = prefixerI('conciliacion-cuentas')
export const ROUTE_COSTO_EMPACADORAS = prefixerI('costo-empacadoras')
export const ROUTE_COSTO_TILAPIERO = prefixerI('costo-tilapiero')
export const ROUTE_DIARIO_GENERAL = prefixerI('diario-general')
export const ROUTE_ESTADO_FINANCIERO_SEGMENTADO = prefixerI('estado-financiero-segmentado')
export const ROUTE_ESTADO_PYG = prefixerI('estado-pyg')
export const ROUTE_INDICADORES = prefixerI('indicadores')
export const ROUTE_MAYOR_GENERAL = prefixerI('mayor-general')
export const ROUTE_MAYOR_PATRIMONIO = prefixerI('mayor-patrimonio')
export const ROUTE_MAYOR_PROCESOS = prefixerI('mayor-procesos')
export const ROUTE_MOVIMIENTOS_CONTABLES = prefixerI('movimientos-contables')
export const ROUTE_MOVIMIENTOS_VENTAS_CXC = prefixerI('movimientos-ventas-cxc')
export const ROUTE_PLAN_CUENTA = prefixerI('plan-cuenta')
export const ROUTE_PLAN_CUENTA_CIAS = prefixerI('plan-cuenta-cias')
export const ROUTE_PLAN_CUENTA_NIIF = prefixerI('plan-cuenta-niif')
export const ROUTE_RESUMEN_RENTAS = prefixerI('resumen-rentas')
